import { ChangeDetectorRef, Injectable } from "@angular/core";

import { CoreService, HttpService } from '../services';
import { BObjectModel, CRUD } from "../models";
import { EffectifModel } from "../models/effectif/effectif.model";
import { RenderType, SelectionMode, Option } from "../models/effectif/option.model";
import { Observable, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { GenericEffectif } from "../models/effectif/genericEffectif.model";
import { InfoLienEffectifs } from "../models/effectif/infoLienEffectifs.model";


@Injectable()
export class EffectifsService {

  public EffectifModel: EffectifModel = new EffectifModel();

  public SelectedAll: Array<string> = new Array<string>();
  public SelectedSelect: Array<GenericEffectif> = new Array<GenericEffectif>();
  public SelectedCycles: Array<string> = new Array<string>();
  public SelectedFilter: Array<string> = new Array<string>();

  public Options: Option;
  /*
 *Permet de choisir le type de rendu des effectifs soit PM soit PP
 */
  public RenderType: RenderType;

  /*
   *Permet d'afficher des cases à cocher ( ou des radios btn si cet attribut est set a "multiple"), ( valeurs possible : none, single, multiple) séléction a retourner dans l'output
   */
  public SelectionMode: SelectionMode;

  /*
   *permet de définir les actions possible pour chaque effectifs
   */
  public Mode: CRUD;

  public isReloading: boolean = true;

  public ModePhoto: string;

  public Model: BObjectModel = new BObjectModel();

  public ListIdChecked: Array<string> = new Array<string>();

  public LstFilterBo: Array<GenericEffectif> = new Array<GenericEffectif>();

  public isLoading: boolean = false;

  constructor(
    public indParam: CoreService,
    protected http: HttpService,
  ) {
  }

  //#region Methodes Publiques

  // Affecte le model qui sera envoyé au back avec les différentes options 
  public setOption() {
    this.EffectifModel.AllData = this.Options.AllData;
    this.EffectifModel.FilteredData = this.Options.FilteredData;
    this.EffectifModel.RenderType = this.Options.RenderType;
    this.EffectifModel.DataType = this.Options.DataType;
    this.EffectifModel.Cycles = this.Options.Cycles;
    this.EffectifModel.SelectedData = this.Options.SelectedData;
    this.EffectifModel.GridFileName = this.Options.GridName;
  }

  // Récupère les données du back
  public loadData() {

    this.isLoading = true;

    this.EffectifModel.Mode = "INITDATA";

    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.EffectifModel).subscribe((data: EffectifModel) => {

      if (!data.HasError) {
        this.EffectifModel.DataListAll = data.DataListAll;
        data.DataListSelect.forEach(effectif => {        
          effectif.Type = this.Options.Title;
        })
        this.EffectifModel.GridFileName = data.GridFileName;
        this.EffectifModel.NombreEffectif = data.NombreEffectif;
        this.EffectifModel.DataListSelect = data.DataListSelect;
        this.EffectifModel.DataListCycles = data.DataListCycles;
        if (this.EffectifModel.AllData.IdOrigin == '') {
          this.EffectifModel.DataListFilter = data.DataListFilter;
          /*          this.LstFilterBo = this.EffectifModel.DataListFilter;*/
        }
        this.Model = data.ModelBo;
        if (this.ListIdChecked && this.ListIdChecked.length > 0) {
          this.EffectifModel.DataListSelect.forEach(effectif => {
            if (this.ListIdChecked.includes(effectif.Id)) {
              effectif.IsSelected = true;
            }
          })
        }

        if (this.Options.Title != "Préinscrits" && this.Options.Title != "Clients" && this.Options.Title != "Responsable d'inscription") {

          this.EffectifModel.Mode = "GETAVAILABLEEFFECTIF";

          this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.EffectifModel).subscribe((data: EffectifModel) => {
            this.EffectifModel.DataListAll = data.DataListAll;
            this.isLoading = false;
          });
        }


      }

    });
  }

  // méthode qui agi après séléction d'un client dans le filtre
  public SelectFilter(value: string) {

    this.EffectifModel.AllData.IdOrigin = value;

  }

  // appel pour aller chercher l'ident/ le nom du bo qu'on souhaite ouvrir
  public getBoName(): Observable<string> {
    this.EffectifModel.Mode = "GETBONAME";
    return this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.EffectifModel).pipe(
      mergeMap((data: EffectifModel) => {
        return of(data.SelectedData.BoName ?? "");
      })
    );
  }

  //#endregion Methodes Publiques

}
